import templateApi from "~/api/template"; // Updated import

const fetchEmailTemplates = ({ commit, state }) => {
  if (state.fetchingEmailTemplates === false && state.emailTemplates.length === 0) {
    commit("SET_FETCHING_EMAIL_TEMPLATES", true);

    templateApi // Updated API reference
      .paginateEmailTemplates(1, 200)
      .then((response) => {
        commit("SET_EMAIL_TEMPLATES", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_EMAIL_TEMPLATES", false);
      });
  }
};

const getEmailTemplateById = async (context, emailTemplateId) => {
  if (context.state.fetchingEmailTemplatesIds.indexOf(emailTemplateId) !== -1
    || context.getters.hasEmailTemplateById(emailTemplateId)) {
    return context.getters.getEmailTemplateById(emailTemplateId);
  }

  context.commit("SET_FETCHING_EMAIL_TEMPLATE_IDS", [emailTemplateId]);

  return templateApi // Updated API reference
    .getTemplateById(emailTemplateId)
    .then((response) => {
      context.commit("UNSET_FETCHING_EMAIL_TEMPLATE_IDS", [emailTemplateId]);
      context.commit("CACHE_EMAIL_TEMPLATE", response.data);

      return response.data;
    });
};

const setEmailTemplates = ({ commit }, emailTemplates) => {
  commit("SET_EMAIL_TEMPLATES", emailTemplates);
};

export default {
  fetchEmailTemplates,
  getEmailTemplateById,
  setEmailTemplates,
};
